export default {
  estimates: {
    addProfile: 'Select profile to add',
    selectProfile: 'Select profile',
    selectMonth: 'Select month',
    select: 'Please select',
    noPositionSelected: 'No positions selected for import.',
    selectPositionsToImport: 'Select positions to import for the month',
    filterByProfile: 'Filter by profile',
    filterByMonth: 'Filter by month',
    filterByPhase: 'Filter by phase',
    positionAccusative1: 'position',
    positionAccusative2_4: 'positions',
    positionAccusative5: 'positions',
    importSelected: 'Import selected',
    importAll: 'Import all',
    withoutAmounts: 'Without amounts',
    withAmounts: 'With amounts',
    clone: 'Clone',
    cloneSelectedEstimateByMonth: 'Clone selected profile for the chosen month',
    cloneEstimateByMonth: 'Clone monthly profile',
    saveStatus: 'Save status',
    sales: 'Sales',
    purchase: 'Purchase',
    fvz: 'FVZ',
    fvs: 'FVS',
    fvzDiff: 'Purchase invoice difference',
    margin: 'Margin',
    orderNumber: 'Order no.',

    noPositions: 'No positions to display.',
    name: 'Name',
    month: 'Month',
    profile: 'Profile',
    client: 'Contractor',
    parameters: 'Parameters',
    salesNetTotal: 'Net sales total',
    purchaseNetTotal: 'Net purchase total',
    positionName: 'Position name',
    positionCountry: 'Country/market',
    positionPhase: 'Phase',
    deliveryTeam: 'Delivery team',
    positionPathPhaseTooltip:
      'The customer-journey stage a given position runs in: <strong>Trigger</strong> (impulse / reach), <strong>Explore</strong> (consideration), <strong>Convert</strong> (sales / performance), <strong>Retain</strong> (customer retention). Used to group and report activity by funnel stage. ',
    amountToInvoice: 'Amount to invoice',
    amountToAccept: 'Amount to accept',

    globalSalesBlockade: 'Active global sales blockade for the month',
    globalPurchaseBlockade: 'Active global purchase blockade for the month',
    addPosition: 'Add position',
    saveAddedPosition: 'Please save the previously added position.',
    category: 'Category',
    amounts: 'Amounts',

    lastPositionModification: 'Last position modification by media planner',
    deletePositionConfirmation:
      'Are you sure you want to delete the visible position?',
    deletePosition: 'Delete position',
    deleteNewPosition: 'Delete new position',
    saveChanges: 'Save changes',
    saveNewPosition: 'Save new position',
    summary: 'Summary',
    positions: 'Positions',
    status: 'Status',
    applications: 'Requests',
    askDeleteProfile: 'Are you sure you want to delete the monthly profile?',
    deleteProfile: 'Delete monthly profile',
    selectTargetMonth:
      'Please select the target month (↑ select at the top of the window ↑).',
    addMonth: 'Add month',
    importPositionFrom: 'Import positions from',

    paeImport: 'Import from PAE',
    openInPae: 'Open in PAE',
    refreshData: 'Refresh data',
    paeImportWarning:
      'Warning. Only purchases will be imported - sales will not be imported due to a sales blockade on the profile.',
    purchaseForm: 'Purchase form',
    paePurchaseForm: 'Format from PAE',
    paePositionNumber: 'PAE position number',
    comment: 'Comment',
    actionGroup: 'Action group',
    paePositionNotReadyToImport:
      'Position: (name: {{name}}, PAE number: {{number}}, amount: {{amount}}) is incomplete. Missing data: {{missingFields}}.',
    paePositionImportErrors: 'Errors during PAE position import.',
    paePositionImportErrorsDescription:
      'Please complete the incorrect positions or do not import them:',

    issueDate: 'Issue date',
    sellDate: 'Sell date',
    invoiceAmount: 'Invoice amount',
    settledAmount: 'Settled amount',
    lastModification: 'Last modification',
    attachment: 'Attachment',
    payments: 'Payments',
    noFVZAssigned: 'No purchase invoices assigned',

    noFVS: 'No issued sales invoices',
    profileSalesBlockade: 'Active sales blockade on the profile',
    profilePurchaseBlockade: 'Active purchase blockade on the profile',
    changeStatus: 'Are you sure you want to change the status?',
    purchaseAmount: 'Purchase amount',
    noPositionsAssigned: 'No positions assigned to this team.',
    positionMonth: 'Item month',
    positionStartDate: 'Item start date',
    positionEndDate: 'Item end date',
    invoiceInstruction: 'Invoicing instructions',
    newUnwritten: 'New position (UNSAVED)',
    invoiced: 'Invoiced',
    accepted: 'Accepted',
    fillField: 'Please fill in the field',
    choosePathPhase: 'Please select the phase.',
    chooseDeliveryTeam: 'Please select the delivery team.',
    noFitDeliveryTeamToPosition:
      'The selected delivery team does not belong to the teams assigned to this position.',
    noFitDeliveryTeamToPathPhase:
      'The selected delivery team handles the phase "{{phase}}", which does not match the phase selected on the campaign position.',
    alertAmountSum100:
      'Percentage amounts must sum up to 100%. Currently, the total is {{sum}}%',
    billed: 'Biller (contractor)',
    deletedPosition: `Position '{{position}}' has been deleted from the system. It cannot be cloned`,
    selectParameter: 'Select parameter',
    chooseParam: 'Choose parameter',
    changeParam: 'Change parameter',
    chooseParamToUpdate: 'Choose parameter to update',
    deleteActionGroup: '[Delete selected group]',
    nameFromDictionary: 'Name from dictionary',
    lack: 'Lack',
    technicalCostAbbreviation: 'TEC',
    commissionAbbreviation: 'COM',
    transferredCommissionAbbreviation: 'TCOM',
    ball: 'Product',
    ballTooltip:
      'Product is our „Ball”, and each „Ball” represents a specific product or service.',
  },

  projects: {
    for: 'For',
    from: 'From',
    to: 'To',
    leadTeam: 'Lead team',
    dateRange: 'Date range',
    parameters: 'Parameters',
    summary: 'Summary',
    orders: 'Orders',
    ordersExecution: 'Orders execution',
    documents: 'Documents',
    fvz: 'FVZ',
    fvzUnsettled: 'FVZ unsettled',
    fvs: 'FVS',
    services: 'Services',
    cancelRequestApproved: 'cancellation request has been approved',
    country: 'Country/market',
    pathPhases: 'Phases',

    purchaserDocNumber: 'Purchaser document number',
    note: 'Note',
    documentsControl: 'Document control',
    cancelApplication: 'Cancellation request',
    edit: 'Edit',
    cancelApplicationSubmitted:
      'A cancellation request has been submitted for {{project}}.',
    dateChangeApplicationSubmitted:
      'A request to change dates has been submitted for {{project}}. New dates are: {{startDate}} - {{endDate}}.',
    cancelVerificationWaiting: 'Awaiting cancellation request verification',
    dateChangeVerificationWaiting: 'Awaiting date change request verification',
    clone: 'Clone',
    withoutAmounts: 'Without amounts',
    withAmounts: 'With amounts',
    applicationVerificationWaiting: 'Awaiting request verification',
    attachments: 'Attachments',
    cancelReason: 'Cancellation reason',
    fillCancelReason: 'Please provide a cancellation reason',
    saveApplication: 'Save request',
    createApplication: 'Create request',
    askRemoveApplication: 'Are you sure you want to delete the request?',
    deleteApplication: 'Delete request',
    applicationContent: 'Request content',
    sendApplication: 'Send request',
    salesNet: 'Sales net',
    salesCommissionAmount: 'Sales commission',
    salesTotal: 'Sales total',
    salesInvoicesSum: 'Sales invoices sum',
    purchaseTotal: 'Purchase total',
    purchaseInvoicesSum: 'Purchase invoices sum',
    margin: 'Margin',
    salesLock: 'Sales lock',
    purchaseLock: 'Purchase lock',
    purchaseDiff: 'Purchase difference',
    noPositions: 'No positions',
    invoicesNumber: 'Invoice numbers',
    activeProfiles: 'Active profiles',
    client: 'Contractor',
    salesInvoicesAmount: 'Sales net (FVS)',
    salesDiff: 'Sales difference',
    purchaseInvoicesAmount: 'Purchase net (FVZ)',
    complianceWithSalesTotal: 'Compliance with sales total',
    parentNumber: 'Commissioning number',
    sales: 'Sales',
    costs: 'Costs',
    action: 'Action',
    specialInvoicingApplication: 'Create custom invoicing request',
    editMonthBlockade: 'Edit monthly blockade',
    addMonthBlockade: 'Add new monthly blockade',
    salesBlockade: 'Sales blockade',
    purchaseBlockade: 'Purchase blockade',
    salesUnblockade: 'Sales unblockade',
    purchaseUnblockade: 'Purchase unblockade',
    noBlockades: 'No monthly blockades in the system.',
    noBlockadesExceptions: 'No monthly blockade exceptions in the system.',
    daysAfterDeadline: 'Number of days after the deadline',
    toClarify: 'To be clarified',
    commentMediaPlanner: "Media planner's comment",
    commentFinance: 'Finance comment',
    label: 'Label',
    noFVZLack: 'No purchase invoices (FVZ) shortages in the system',
    monthBlockades: 'Monthly blockades',
    newMonthBlockade: 'New monthly blockade',
    globalBlockades: 'Global blockades',
    exceptionBlockades: 'Exception blockades',
    historyExceptionBlockades: 'History of exception blockades',
    viewMonthBlockadeException: 'View exception to global blockades',
    editMonthBlockadeException: 'Edit exception to global blockades',
    addMonthBlockadeException: 'Add new exception to global blockades',
    newMonthUnblockade: 'New exception',
    askDeleteBlockade:
      'Are you sure you want to delete the global monthly blockade?',
    askDeleteBlockadeException:
      'Are you sure you want to delete the exception to the global monthly blockade?',

    approved: 'Approved',
    rejected: 'Rejected',
    waited: 'Waited',
    dateToDeleteBlockade: 'Date of automatic removal exception',
    addExceptionReason: 'Reason',
    byProfiles: 'By profiles',
    byPublishers: 'By publishers',
    copyNumberToClipboard: 'Copy number to clipboard',
  },
  contract: {
    contractHasPositionContractNotRequired:
      'The contract contains positions that do not require a contract: {{positions}}. It cannot be sent for signing or signed.',
    tv: 'Contract TV',
    contractSystemNumber: 'Contract with system no.',
    contractNew: 'Adding a new order',
    contractNewFromFile: 'Adding a new contract from a file on disk',
    contractNewTvFromFile: 'Adding a new contract TV from a file on disk',
    noContracts: 'No contracts to display.',
    contracts: 'Contracts',
    contractsToSign: 'Signing contracts',
    contract: 'Contract',
    all: 'All',
    entered: 'My entered',
    waitingForSigning: 'Waiting for signing',
    unsigned: 'Refusal to sign',
    waitingToSignFromMe: 'Waiting to sign from me',
    signByMe: 'All',
    signedNotSent: 'Signed, not sent',
    authorizedPerson: 'Authorized person',
    general: 'General data',
    contractorLabel: 'Contractor (Publisher)',
    amountLabel: 'Contract amount (PLN)',
    numberLabel: 'Contract number',
    fileLabel: 'Contract file (PDF)',
    additionalEmailContent: 'Additional email content',
    notSendAutomatically: 'Do not send automatically',
    signedOutsidePokLabel: 'Signed outside POK',
    positions: 'Positions',
    contractorEmail: 'Contractor email',
    contractorLanguage: 'Client communication language',
    stepForward: 'Step forward',
    saveAndStepForward: 'Save and step forward',
    sendToSigning: 'Send to signing',
    markAsSigned: 'Mark as signed',
    askDeleteContract: 'Are you sure you want to delete the contract?',
    askUpdateContract: 'Are you sure you want to update the contract?',
    nip: 'VAT ID',
    unwrittenUppercase: 'UNSAVED',
    notAssignedAmount: 'Unassigned amount',
    fillAllFields: 'Fill in all visible fields with unsettled amount',
    fillNotAssignedAmount: 'Fill with unsettled amount',
    contractAmountUppercase: 'CONTRACT AMOUNT',
    unsettledAmountUppercase: 'UNSETTLED AMOUNT',
    unsettledAmount: 'Unsettled amount',
    showSettled: 'Show items with fully settled contracts',
    sumExceedsContractAmount:
      'The sum of recorded assignments exceeds the total contract amount.',
    hideAttachment: 'Hide attachment',
    showAttachment: 'Show attachment',
    warningChangeSupplierOrProject:
      'The “{{project}}” and “{{contractor}}” fields are locked because amounts have already been assigned on the “{{tab}}” tab. To change them, first remove the amounts on the “{{tab}}” tab.',
    selectToUpdate: 'Select contract to update',
    warningSelectToUpdate:
      'Note: You must select the assignment to be updated. An attachment from the currently processed assignment will be inserted into the selected one, and the current assignment will be automatically deleted.',
    askSigningContracts: 'Are you sure you want to sign the contracts?',
    signAllContracts: 'Sign all contracts',
    signContracts: 'Sign selected contracts ({{number}})',
    signContract: 'Sign',
    sentByHand: 'Mark as sent',
    unsignContract: 'Refuse to sign',
    selected: 'selected',
    contractRejection: 'Refusal to sign the contract',
    rejectionContractReason: 'Reason for refusal',
    rejectContract: 'Refuse to sign',
    fillRejectionReason:
      'Please provide a reason for refusing to sign the contract.',

    askSentByHandsContract: 'Has the contract been sent?',
    sentOutOfSystem: 'The contract has been sent outside the system.',
    monthFilter: 'Filter by month',
    signDate: 'Signing date',
    unsignDate: 'Refusal to sign date',
    waitingForSigningDate: 'Waiting for signing date',
    hasNegativeAmounts:
      'The contract binding amount exceeds the position amount {{estimate}}. Are you sure you want to save the contract?',
    hasMoreThenAvailableAmounts:
      'The contract binding amount exceeds the unsettled position amount {{estimate}}. Are you sure you want to save the contract?',
    signingInProgress: 'Please wait, signing contracts in progress...',
  },

  timeLine: {
    selectMonth: 'Select month',
    all: 'All',
    title: 'Timeline',
    month: 'Month',
    refresh: 'Refresh',
    profile: 'Profile',
    stageDetails: 'Stage details',
    stage: 'Stage',
    checklist: 'CHECKLIST',
    errors: 'Errors',
    hints: 'HINTS',
    auto: 'Auto',
    requiresAttention: 'ACTIONS REQUIRED',
    information: 'INFORMATION',
    requestInfo: 'REQUESTS',
    allClear: 'All clear',
    newHint: 'New hint',
    editHint: 'Edit hint',
    addHint: 'Add hint',
    hintText: 'Hint text',
    order: 'Order',
    hintTextEn: 'Hint text in English',
    url: 'URL',
    deadline: 'Deadline',
    deadlineWithTime: 'Deadline: {{deadline}}',
    noHints: 'No hints to display.',
    timeLineHints: 'Hints for timeline stages',
    stageOnTimeline: 'Stage on timeline',
    description: 'Description',
    descriptionEn: 'Description in English',
    linkInSystem: 'Link in system',
    automatic: 'Automatic',
    showInChecklist: 'Show in checklist',
    priority: 'Priority',
    timeLineSteps: 'Timeline - Steps',
    collapse: 'Collapse',
    expand: 'Expand',
    manual: 'Manual',
    future: 'UPCOMING',
  },
} as const;
